import { ApolloClient } from '@apollo/client';

import { ARROW_LEFT, ARROW_RIGHT } from 'approot/shared/ally/keyboard.hooks';
import {
  getFirstSortValue,
  getNewSortValue,
  sortComponents,
} from '../activity-builder.utils';
import { ColumnData } from './droppable.constants';
import { findColumns, moveBetweenColumns } from './droppable.utils';
import { SectionOrSubSection } from '../activity-builder.constants';

export function getPreceedingComponentSort(
  section: SectionOrSubSection | undefined,
  column: ColumnData
) {
  const components = sortComponents(section?.components || []);
  const currentIndex = components.findIndex(c => c.id === column.componentId);
  return getNewSortValue({
    components,
    componentId: components[currentIndex - 1]?.id,
  });
}

export function handleMoveBetweenColumns(
  client: ApolloClient<any>,
  section: SectionOrSubSection | undefined,
  componentId: string,
  columnData: ColumnData,
  direction: typeof ARROW_LEFT | typeof ARROW_RIGHT
) {
  const columnsComponent = findColumns(section, columnData.componentId);
  const currentColumn = columnsComponent.columns?.find(
    col => col.columnId === columnData.id
  );
  const currentColumnIndex = currentColumn?.index || 0;
  const nextColumn =
    columnsComponent.columns?.[
      direction === ARROW_LEFT ? currentColumnIndex - 1 : currentColumnIndex + 1
    ];

  const nextColumnComponents = sortComponents(nextColumn?.components || []);
  const newSortValue = getFirstSortValue(nextColumnComponents);
  return moveBetweenColumns(
    client,
    section,
    newSortValue,
    {
      id: componentId,
      column: {
        id: columnData.id,
        componentId: columnData.componentId,
      },
    },
    {
      id: nextColumn?.columnId || '',
      componentId: columnData.componentId,
    }
  );
}
